import _taggedTemplateLiteral from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import { gql } from "@apollo/client";
export var GET_ADULT_MODE = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query AdultMode {\n    adultMode\n  }\n"])));